export default {
  props: ['item', 'theme', 'panel', 'editing'],
  computed: {
    timelineItem() {
      return this.editing;
    },

    animation: {
      get() {
        return this.getField('animation');
      },

      set(animation) {
        this.setField('animation', animation);
      },
    },

    panelFields() {
      return {
        ...this.item.fields,
        ...this.panel.settings,
        ...(this.editing.fields || {}),
      };
    },

    themeFields() {
      return {
        ...this.theme.settings,
        ...this.item.fields,
      };
    },
  },

  methods: {
    setField(field, value) {
      this.$store.dispatch('setTimelineField', {
        timelineId: this.editing?.timeline_id,
        field,
        value,
      });

      // Should be safe to always fire off an updateTimeline socket message,
      // since live won't update without the force flag.
      this.$store.dispatch('updatePreviewTimeline');
      this.$store.dispatch('updateTimeline');
    },

    getField(field) {
      return field in this.item.fields
        ? this.item.fields[field] : this.theme?.settings?.[field];
    },

    getNiceTime(time) {
      return Math.floor(time / 1000);
    },

    setNiceTime(field, ms) {
      this.setField(field, ms * 1000);
    },
  },
};
